import React from 'react';
import NiceModal, {useModal} from "@ebay/nice-modal-react";
import {modalClose} from "../genericFunctions";
import SlideOver, {SlideOverProps} from "../../generic/SlideOver";
import TrainingAttachmentsTable, {
    TrainingAttachmentTableProps
} from "../../../pages/consumers/training/components/Training/TrainingAttachmentsTable";


interface OwnProps extends SlideOverProps, TrainingAttachmentTableProps {}

type Props = OwnProps;

// @ts-ignore
const TrainingAttachmentsTableModal = NiceModal.create<Props>(({onClose, header, ...rest}) => {
    const modal = useModal()

    const handleClose = (e) => {
        modalClose(e, modal, onClose)
    }

    return (
        <SlideOver onClose={handleClose} open={modal.visible} afterClose={modal.remove} title={header}>
            <TrainingAttachmentsTable {...rest}/>
        </SlideOver>
    )
})

export default TrainingAttachmentsTableModal;
